import { createAction } from "@reduxjs/toolkit";

import { updatePageTitle, updateRegionData } from "./appSlice";

const getRegionData = createAction("app/getRegionData");

export { getRegionData, updatePageTitle, updateRegionData };
